<template>
    <div class="layout-main-container">
        <div class="layout-main bac">
            <TabView @tab-change="e => loadTabContent(e.index)" style="direction: rtl;">
                <TabPanel>
                    <template #header>
                        <i :class="['pi', 'pi-comments']" style="margin-left: 1rem; font-size: 1.25rem;" />
                        <span>{{ $t('FREE_CHATS') }}</span>
                    </template>
                    <div class="col-12 p-0 border-round-xl">
                        <div class="card" >
                            <div class="p-fluid formgrid grid justify-content-center align-items-center gap-2">
                                <div class="field col-12 md:col-4 lg:col-3 m-0 ">
                                    <UserSelector :users="users" v-model="selectedUser"
                                        style="min-width: 9rem !important; max-width: 100% !important; direction: rtl !important;"
                                        class="w-full " />
                                </div>
                                <div class="field col-12 md:col-2 lg:col-1 m-0" style="min-width: fit-content;">
                                    <Button :label="$t('NEW_CHAT_THREAD')" @click="startNewChat"
                                        :disabled="!canStartNewChat" class="w-full surface-60" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-for="message in freeChatThreads" :key="message" class="notification_container card mt-4"
                        style="cursor: pointer;">
                        <div class="flex gap-1 w-full" @click="openFreeChat(message)">
                            <div style="margin-left: 10px;" class="notification_container">
                                <img :src="getOtherUserId(message).imageUrl" class="user_avatar"
                                    @click="showUserInfo(getOtherUserId(message).id)" />
                            </div>
                            <div>
                                <div class="text-xs text-blue-500">
                                    {{ utils.formatDate(message.timestamp) }}
                                </div>
                                <div class="flex gap-1">
                                    <div>
                                        <font-awesome-icon :icon="['fas', 'circle-exclamation']" size="lg" beat
                                            v-if="message.hasBeenUpdated === true" style="margin: 0 5px 0 5px;" />
                                    </div>
                                    <div
                                        class=" white-space-nowrap overflow-hidden text-overflow-ellipsis w-9rem md:w-24rem lg:w-24rem">
                                        {{ message.text }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div @click="deleteMessages(message.chatThreadId)"
                            class="surface-ground border-circle text-gray-700">
                            <i :class="['pi', 'pi-trash']"
                                style="font-size: 1.25rem; cursor: pointer; margin: 0.75rem" />
                        </div>
                    </div>



                </TabPanel>
                <TabPanel>
                    <template #header>
                        <i :class="['pi', 'pi-envelope']" style="margin-left: 1rem; font-size: 1.25rem;" />
                        <span>{{ $t('OPEARTIONS_CHATS') }}</span>
                    </template>

                    <div v-if="isEmptyOpMessages" class="horizontally_centered_content">
                        <div class=".surface-ground flex align-items-center justify-content-center overflow-hidden">
                            <div class="flex flex-column align-items-center justify-content-center">
                                <div
                                    class="w-full .surface-card py-4 px-8 sm:px-8 flex flex-column align-items-center border-round-xl">
                                    <div class="grid flex flex-column align-items-center mt-2">
                                        <div class="flex justify-content-center align-items-center bg-blue-600 border-circle"
                                            style="height: 3.2rem; width: 3.2rem">
                                            <i class="pi pi-fw pi-exclamation-circle text-2xl text-white"></i>
                                        </div>
                                        <h1 class="text-900 font-bold text-3xl mb-2">{{ $t('EMPTYMSG') }}</h1>
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div v-else>
                        <div v-for="notification in operationsMessagesNotifications" :key="notification" class="card">
                            <div class="flex justify-content-between gap-2">
                                <div class="flex gap-3">
                                    <div>
                                        <img :src="notification.issuer.imageUrl" class="user_avatar" />
                                    </div>
                                    <div>
                                        <div class="flex flex-column gap-2">
                                            <div class="text-sm text-gray-500">
                                                {{ utils.formatDate(notification.chatMessage.timestamp) }}
                                            </div>
                                            <div>
                                                <div>
                                                    {{ notification.chatMessage.text }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="surface-ground border-circle text-gray-700 p-2">
                                    <i :class="['pi', 'pi-link']"
                                        style="cursor: pointer; font-size: 1.25rem; margin: 0.75rem;"
                                        @click="openOperation(notification)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>
            </TabView>
        </div>
    </div>
</template>

<script setup>
import { computed, onBeforeMount, ref, onBeforeUnmount, onErrorCaptured } from 'vue'
import { useDialog } from 'primevue/usedialog'
import { useI18n } from 'vue-i18n'
import { useGlobalStore } from '@/stores/global'
import { useAuthStore } from '@/stores/auth'
import { useToast } from "primevue/usetoast"
import { handleError } from '@/helpers/ErrorHandler'
import UserSelector from '@/components/UserSelector.vue'
import FreeChatThread from '@/components/FreeChatThread.vue'
import UserOverview from '@/components/UserOverview.vue'
import router from '@/router/router'
import utils from '@/helpers/Utils'
import notificationService from '@/service/NotificationService'
import userService from '@/service/UserService'
import chatService from '@/service/ChatService'
import socketService from '@/service/SocketService'
import { socketMessageTypeEnum } from '@/helpers/Constants'
import SocketListener from '@/model/SocketListener'

const authStore = useAuthStore()
const toast = useToast()
const i18n = useI18n()
const dialog = useDialog()
const globalStore = useGlobalStore()

const operationsMessagesNotifications = ref([])
const freeChatThreads = ref([])

const users = ref([])
const selectedUser = ref(null)

let uniqueId

onBeforeUnmount(() => {
    socketService.removeListener(uniqueId)
})

onBeforeMount(async () => {
    uniqueId = 'FREE_CHAT_PANEL' + new Date().getTime()
    socketService.addListener(socketMessageTypeEnum.FREE_CHAT_MESSAGE, new SocketListener(uniqueId, handleInstantMessage, true))
    try {
        loadTabContent(0)
    } catch (error) {
        handleError(authStore, toast, i18n, error)
    }
})

onErrorCaptured((err, instance, info) => {
    return handleError(authStore, toast, i18n, err, instance, info)
})

const isEmptyOpMessages = computed(() => {
    return operationsMessagesNotifications.value.length === 0
})

const openOperation = (notification) => {
    globalStore.sharedData = notification.operation.id
    notificationService.markAsRead(notification)
    authStore.unreadChatsMessages--
    authStore.amIAdmin() ? router.push('/controlPanel') : router.push('/operations')
}

const startNewChat = () => {
    dialog.open(FreeChatThread, {
        emits: {
            onError: (e) => {
                handleError(authStore, toast, i18n, e)
            }
        },
        props: {
            header: i18n.t('CHAT'),
            style: {
                width: '50vw'
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            receiverId: selectedUser.value.id
        }, onClose: async () => {
            const response = await chatService.getChatThreads()
            freeChatThreads.value = response.result.collection
        }
    })
}

const openFreeChat = async (message) => {
    authStore.unreadChatsMessages--
    dialog.open(FreeChatThread, {
        emits: {
            onError: (e) => {
                handleError(authStore, toast, i18n, e)
            }
        },
        props: {
            header: i18n.t('CHAT'),
            style: {
                width: '50vw'
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            receiverId: getOtherUserId(message).id,
            chatThreadId: message.chatThreadId
        }, onClose: (e) => {
            message.hasBeenUpdated = false
            notificationService.markAsReadByChatThread(message.chatThreadId)
            const issuedByUser = e.data === undefined || e.data.causedByLogout === false
            if (issuedByUser && !authStore.amIAdmin()) {
                chatService.markMessagesRead(message.chatThreadId)
            }
        }
    })
}

const canStartNewChat = computed(() => {
    return selectedUser.value !== null && selectedUser.value !== undefined &&
        freeChatThreads.value.filter(m => m.sender.id === selectedUser.value.id || m.receiver.id === selectedUser.value.id).length == 0
})

const getOtherUserId = (message) => {
    return message.sender.id === authStore.user.id ? message.receiver : message.sender
}

const handleInstantMessage = (message) => {
    const chatMessage = freeChatThreads.value.filter(m => m.chatThreadId === message.chatThreadId)
    if (chatMessage.length > 0) {
        chatMessage[0].hasBeenUpdated = true
        chatMessage[0].timestamp = message.timestamp
        chatMessage[0].text = message.text
    } else {
        message.hasBeenUpdated = true
        freeChatThreads.value.push(message)
    }
}

const deleteMessages = async (chatThreadId) => {
    await chatService.deleteMessages(chatThreadId)
    const response = await chatService.getChatThreads()
    freeChatThreads.value = response.result.collection
}

const showUserInfo = (userId) => {
    dialog.open(UserOverview, {
        props: {
            header: i18n.t('USER_INFO'),
            style: {
                width: '20em',
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            userId: userId,
        }
    })
}

const loadTabContent = async (index) => {
    if (index === 0) {
        const response = await chatService.getChatThreads()
        freeChatThreads.value = response.result.collection
        userService.decorate(freeChatThreads.value.map(e => e.sender).concat(freeChatThreads.value.map(e => e.receiver)))
        const allUsers = await userService.getAllUsers(true)
        users.value = allUsers.filter(u => authStore.user.username !== u.email)
    } else {
        const response = await notificationService.loadUnreadMessages()
        userService.decorate(response.map(e => e.issuer).concat(response.map(e => e.receiver)))
        operationsMessagesNotifications.value = response.filter(n => n.operation !== null)
    }
}

</script>

<style scoped>

.card {
direction: rtl;
  background-color: var(--surface-section);
  
  border: 1px solid var(--surface-border);
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: var(--card-shadow);
  border-radius: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}

.on_hover_pointer:hover {
    cursor: pointer;
}

.user_avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.notification_container {
    direction: rtl;
    display: flex;
    align-items: center;
    justify-content: space-between;
}



</style>